import styled, { createGlobalStyle } from 'styled-components';

import { TabsHeader } from '~/components/TabsContainer/styles';
import grid from '~/styles/grid';

import {
  HeaderContainer,
  HeaderCloseButton,
  HeaderTitle,
} from '../Sidesheet/styles';

export const SidesheetCustomStyle = createGlobalStyle<any>`
  ${HeaderContainer} {
    background-color: #fff;
    margin-left: 0;
    padding-left: ${grid.lg};
    margin-bottom: 0;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  ${HeaderTitle} {
    max-width: 53.571rem;
  }

  ${HeaderCloseButton} {
    top: 0;
    margin-top: ${grid['3xl']};
  }
`;

export const Container = styled.div`
  ${TabsHeader} {
    background-color: #fff;
    padding-left: ${grid.lg};
    position: sticky;
    top: ${() => `calc(${grid.lg} + 3.571rem)`};
    z-index: 1;
  }

  .MuiBox-root {
    padding: 0;
  }
`;
